import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Landing from "@/pages/Landing";
import MenuPage from "@/pages/MenuPage";
import AccountPage from "@/pages/AccountPage";
import AdminPage from "@/pages/AdminPage";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import RefundPolicy from "@/pages/RefundPolicy";
import Blogs from "@/pages/Blogs";
import BlogPost from "@/pages/BlogPost";
import Affiliates from "@/pages/Affiliates";
import AuthCallback from "@/auth/AuthCallback";
import { AuthProvider } from "@/auth/AuthContext";
import { CartProvider } from "@/cart/CartProvider";
import { Toaster } from "@/components/ui/sonner";
import AnnouncementBar from "@/components/landing/AnnouncementBar";
import WelcomePopup from "@/components/landing/WelcomePopup";
import PayBalancePage from "@/pages/PayBalancePage";

function AppRouter() {
    const location = useLocation();
    // CRITICAL: Detect Emergent OAuth callback during render (NOT useEffect)
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <CartProvider>
            <AnnouncementBar />
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/menu" element={<MenuPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/refund" element={<RefundPolicy />} />
                <Route path="/blogs" element={<Blogs />} />
                <Route path="/blogs/:slug" element={<BlogPost />} />
                <Route path="/affiliates" element={<Affiliates />} />
                <Route path="/pay-balance/:order_id" element={<PayBalancePage />} />
            </Routes>
            <WelcomePopup />
        </CartProvider>
    );
}

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AppRouter />
                </AuthProvider>
            </BrowserRouter>
            <Toaster
                position="top-center"
                richColors
                toastOptions={{
                    style: { fontFamily: '"DM Sans", sans-serif' },
                }}
            />
        </div>
    );
}

export default App;
